<div class="blur-content">
  <div [ngClass]="{ 'page-container': true, sbar_collapsed: mobileView }" style="background-color: #f2f8fa !important">
    <app-sidebar-menu [selected]="selected" [isAdmin]="true"></app-sidebar-menu>
    <!-- main content area start -->
    <div class="main-content">
      <app-header></app-header>
      <div class="main-content-inner">
        <!-- market value area start -->
        <div class="row mt-5">
          <div class="col-12" style="padding-right: 0 !important; margin-right: 0 !important">
            <div class="card">
              <div class="card-body">
                <div *ngIf="loadingWorkflow===false">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <h4 class="mb-0">Workflow Actions</h4>
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="mr-2">
                        <button *ngIf="selectedWorkflowSteps.length > 0" class="btn btn-sm btn-danger mr-2" (click)="deleteSelectedWorkflowActions()">
                          Delete
                        </button>
                      </div>
                      <div class="search-container mr-2">
                        <input type="text" 
                               [(ngModel)]="searchStatus"
                               (ngModelChange)="applyFilter()"
                               class="form-control search-input" 
                               placeholder="Search by status">
                        <app-search-icon class="search-icon"></app-search-icon>
                      </div>
                      <div class="search-container">
                        <input type="text" 
                               [(ngModel)]="searchAssignTo"
                               (ngModelChange)="applyFilter()"
                               class="form-control search-input" 
                               placeholder="Search by assignee...">
                        <app-search-icon class="search-icon"></app-search-icon>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="table-responsive">
                    <table class="table table-sm text-sm table-bordered">
                      <thead>
                        <tr class="text-center">
                          <!-- Always visible headings -->
                          <th *ngIf="areAdditionalHeadingsVisible"></th>
                          <th [attr.colspan]="!areAdditionalHeadingsVisible ? 4 : 1">
                            <div class="flex-container" (click)="sort('workflowTitle')">
                              Workflow Title <span><i class="fa fa-sort"></i></span>
                            </div>
                          </th>
                          <th [attr.colspan]="!areAdditionalHeadingsVisible ? 2 : 1">
                            <div class="flex-container" (click)="sort('entityName')">
                              Entity Name <span><i class="fa fa-sort"></i></span>
                            </div>
                          </th>
                          <!-- Conditionally visible headings -->
                          <th *ngIf="areAdditionalHeadingsVisible">
                              Entity Id
                          </th>
                          <th *ngIf="areAdditionalHeadingsVisible">
                              Step
                          </th>
                          <th *ngIf="areAdditionalHeadingsVisible">
                              Action
                          </th>
                          <th [attr.colspan]="!areAdditionalHeadingsVisible ? 4 : 1">
                            <div class="flex-container" (click)="sort('departmentName')">
                              Department<span><i class="fa fa-sort"></i></span>
                            </div>
                          </th>
                          <th *ngIf="areAdditionalHeadingsVisible">
                              Assign To
                          </th>
                          <th [attr.colspan]="!areAdditionalHeadingsVisible ? 1 : 1">
                            <div class="flex-container" (click)="sort('createdAT')">
                              Date Created<span><i class="fa fa-sort"></i></span>
                            </div>
                          </th>
                          <th *ngIf="areAdditionalHeadingsVisible">
                              Date Due
                          </th>
                          <th *ngIf="areAdditionalHeadingsVisible">
                              Status
                          </th>
                          <th>
                             <div class="flex-container" (click)="sort('client')">
                              Client<span><i class="fa fa-sort"></i></span>
                            </div>
                          </th>
                          <th>
                             <div class="flex-container" (click)="sort('startDate')">
                             Start Date<span><i class="fa fa-sort"></i></span>
                            </div>
                          </th>
                          <th *ngIf="areAdditionalHeadingsVisible">File</th>
                          <th [attr.colspan]="!areAdditionalHeadingsVisible ? 3 : 1">
                            <button class="btn btn-sm btn-info" (click)="toggleAllGroups()"
                              [title]="allGroupsExpanded ? 'Collapse All' : 'Expand All'" [disabled]="isTogglingAllGroups">
                              <!-- <span *ngIf="isTogglingAllGroups" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> -->
                              <svg *ngIf="!allGroupsExpanded && !isTogglingAllGroups" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                              </svg>
                              <svg *ngIf="allGroupsExpanded && !isTogglingAllGroups" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                              </svg>
                            </button>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="filteredWorkflows && getGroupKeys().length > 0; else other_content">
                          <ng-container *ngFor="let groupKey of getGroupKeys()">
                            <!-- Parent Row -->
                    
                            <tr class="parent-row" (click)="toggleGroup(groupKey)" *ngIf="filteredWorkflows[groupKey]">
                              <td [attr.colspan]="!areAdditionalHeadingsVisible ? 4 : 2">{{ filteredWorkflows[groupKey]?.workflowTitle }}</td>
                              <td [attr.colspan]="!areAdditionalHeadingsVisible ? 2 : 1" >{{ filteredWorkflows[groupKey]?.entityName }}</td>
                              <td *ngIf="areAdditionalHeadingsVisible" colspan="3"></td>
                              <td [attr.colspan]="!areAdditionalHeadingsVisible ? 4 : 1">{{ filteredWorkflows[groupKey]?.departmentName}}</td>
                              <td *ngIf="areAdditionalHeadingsVisible" colspan="1"></td>
                              <td [attr.colspan]="!areAdditionalHeadingsVisible ? 1 : 1">{{ filteredWorkflows[groupKey].createdAT | date: 'dd-MM-yyyy'  }}</td>
                              <td *ngIf="areAdditionalHeadingsVisible" colspan="2"></td>
                              <td >{{  filteredWorkflows[groupKey].client || 'N/A' }}</td>
                              <td >{{  filteredWorkflows[groupKey].startDate | date: 'dd-MM-yyyy'}}</td>
                              <td *ngIf="areAdditionalHeadingsVisible"></td>
                              <td [attr.colspan]="areAdditionalHeadingsVisible ? 5 : 4"  class="text-center d-flex justify-content-center">
                              <button class="btn btn-sm btn-info mr-5" (click)="openNoteModal(groupKey)" title="Add/Edit Note">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-stickies-fill" viewBox="0 0 16 16">
                                  <path d="M0 1.5V13a1 1 0 0 0 1 1V1.5a.5.5 0 0 1 .5-.5H14a1 1 0 0 0-1-1H1.5A1.5 1.5 0 0 0 0 1.5"/>
                                  <path d="M3.5 2A1.5 1.5 0 0 0 2 3.5v11A1.5 1.5 0 0 0 3.5 16h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 16 9.586V3.5A1.5 1.5 0 0 0 14.5 2zm6 8.5a1 1 0 0 1 1-1h4.396a.25.25 0 0 1 .177.427l-5.146 5.146a.25.25 0 0 1-.427-.177z"/>
                                </svg>
                              </button>
                              <button class="btn btn-sm btn-info">
                                  <svg *ngIf="filteredWorkflows[groupKey]?.isOpen" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-up" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M7.646 2.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 3.707 2.354 9.354a.5.5 0 1 1-.708-.708z"/>
                                    <path fill-rule="evenodd" d="M7.646 6.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/>
                                  </svg>
                                  <svg *ngIf="!filteredWorkflows[groupKey]?.isOpen" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-down" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                                    <path fill-rule="evenodd" d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                                  </svg>
                               </button>
                              </td>
                            </tr>
                            <!-- Child Rows -->
                            <ng-container *ngIf="filteredWorkflows[groupKey]?.isOpen">
                              <tr *ngFor="let workflow of filteredWorkflows[groupKey]?.data" class="text-center">
                                <td *ngIf="areAdditionalHeadingsVisible"><input type="checkbox" [(ngModel)]="workflow.isSelected" (change)="onCheckboxChange(workflow)"></td>
                                <td>{{ workflow.workflowTitle }}</td>
                                <td>{{ workflow.entityName }}</td>
                                <td>{{ workflow.triggerEntityId }}</td>
                                <td>{{ workflow.stepNumber }}</td>
                                <td>{{ workflow.title }}</td>
                                <td>{{ workflow.departmentName }}</td>
                                <td ><select id="assignTo" name="assignTo" class="custom-select custom-select-sm" [(ngModel)]="workflow.assignTo"
                                    (change)="onAssignTo(workflow)">
                                    <option value="" disabled selected> Select</option>
                                    <option *ngFor="let admin of admins" [value]='admin.name'>{{ admin.name }}</option>
                                  </select></td>
                                <td [attr.colspan]="!areAdditionalHeadingsVisible ? 2 : 1">{{ workflow.createdAT | date: 'dd-MM-yyyy' }}</td>
                                <td><input type="date" (keydown)="onKeyDown($event)" pattern="'dd-MM-yyyy'" title="Select Date From Calendar" class="form-control"
                                    [(ngModel)]="workflow.dueDate" (ngModelChange)="onDueDateChange(workflow)"></td>
                                <td> 
                                  <select id="status" name="status" class="custom-select custom-select-sm" [(ngModel)]="workflow.status"
                                    (change)="onStatusChange(workflow)">
                                    <option value="" disabled selected> Status</option>
                                    <option *ngFor="let value of status" [value]='value'>{{ value }}</option>
                                  </select>
                                </td>
                                <!-- <td *ngIf="areAdditionalHeadingsVisible">{{ workflow.client || 'N/A' }}</td>
                                <td *ngIf="areAdditionalHeadingsVisible">{{ workflow.startDate | date: 'dd-MM-yyyy'}}</td> -->
                                <td *ngIf="areAdditionalHeadingsVisible"></td>
                                <td *ngIf="areAdditionalHeadingsVisible"></td>
                                <td class="d-flex justify-content-center">
                                  <button class="btn btn-sm btn-info" [title]="workflow.fileName && workflow.fileId ? 'View File' : 'No File'"
                                    (click)="onClickView(workflow)" [disabled]="!workflow.fileName || !workflow.fileId">
                                    <i class="fa fa-file-text-o" style="font-size: 18px"></i>
                                  </button>
                                </td>
                                <td class="text-center">
                                  <button title="Delete" class="btn btn-sm btn-info ml-1" (click)="deleteworkflowAction(workflow)">
                                    <i class="fa fa-trash-o" style="font-size: 18px"></i>
                                  </button>
                                </td>
                              </tr>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                        <ng-template #other_content>
                          <tr><td colspan="12">No data</td></tr>
                        </ng-template>
                      </tbody>
                    </table>
                    
                  </div>
                </div>
                <div *ngIf="loadingWorkflow===true">
                  <li class="t_loader">
                    <div class="card__desc load" id="long"></div>
                  </li>
                  <li class="t_loader">
                    <div class="card__desc load"></div>
                  </li>
                  <li class="t_loader">
                    <div class="card__desc load" id="long"></div>
                  </li>
                  <li class="t_loader">
                    <div class="card__desc load"></div>
                  </li>
                  <li class="t_loader">
                    <div class="card__desc load" id="long"></div>
                  </li>
                  <li class="t_loader">
                    <div class="card__desc load"></div>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- market value area end -->
      </div>
      <!-- main content area end -->
    </div>
  </div>
</div>

<app-confirmation-modal 
  [title]="'Delete Workflow Action'"
  [message]="'Are you sure you want to delete selected Workflow Actions?'"
  [note]="'(Note: This action cannot be undone)'"
  [confirmButtonText]="'Delete'"
  [cancelButtonText]="'Cancel'"
  [successMessage]="successMessage"
  [loading]="loading"
  [(isVisible)]="isModalVisible"
  (confirm)="confirmDelete()"
  (cancel)="onCancel()"
  (close)="onClose()"
></app-confirmation-modal>

<app-workflow-note-modal
  *ngIf="selectedWorkflowForNote"
  [isVisible]="isNoteModalVisible"
  [workflowTitle]="selectedWorkflowForNote?.workflowTitle || ''"
  [entityName]="selectedWorkflowForNote?.entityName || ''"
  [createdAT]="selectedWorkflowForNote?.createdAT || ''"
  [currentNote]="selectedWorkflowForNote?.data && selectedWorkflowForNote.data.length > 0 ? selectedWorkflowForNote.data[0].note : ''"
  [successMessage]="successMessage"
  (saveNote)="saveWorkflowNote($event)"
  (closeModal)="onNoteModalClose()"
></app-workflow-note-modal>